import { Component } from '@angular/core'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeLabelValuePairSkeletonComponent } from 'se-fe-label-value-pair/skeleton'
import { SeFeGridModule } from 'se-fe-grid'

@Component({
  selector: 'se-po-profile-side-panel-header-skeleton',
  standalone: true,
  imports: [
    SeFeCardHeaderSkeletonComponent,
    SeFeLabelValuePairSkeletonComponent,
    SeFeGridModule,
  ],
  template: `
    <se-fe-card-header-skeleton
      seFeDataSize="section"
      [seFeDataTitle]="true"
      seFeDataVisual="avatar|500">
    </se-fe-card-header-skeleton>
    <div class="card">
      <div class="content">
        <se-fe-grid seFeGridOpts="snug">
          <se-fe-grid-cell seFeGridOpts="1/2">
            <se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton>
          </se-fe-grid-cell>
          <se-fe-grid-cell seFeGridOpts="1/2">
            <se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton>
          </se-fe-grid-cell>
        </se-fe-grid>
      </div>
    </div>
  `,
  styles: [`
    .card {
      padding: var(--se-fe-card-padding);
    }
    .content {
      margin-top: -20px;
      padding-left: 90px;
    }
  `]
})
export class ProfileSidePanelHeaderSkeletonComponent {}
